module.exports = __webpack_public_path__ + "img/map-view-white.c3839aae.svg";